// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2YBNg","content":"LayoutSettings_content__2m-aX"};